import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

const MAX_DIALOG_WIDTH = 927;
const HORIZONTAL_MARGIN_MD = 90;
const HORIZONTAL_MARGIN_XS = 40;
const VERTICAL_MARGIN_MD = 170;
const VERTICAL_MARGIN_XS = 86;

export default makeStyles((theme: MuiTheme) => ({
  root: {
    "& .MuiPaper-root": {
      minWidth: `min(calc(100vw - ${HORIZONTAL_MARGIN_MD}px), ${MAX_DIALOG_WIDTH}px)`,
      maxWidth: MAX_DIALOG_WIDTH,
      width: `calc(100vw - ${HORIZONTAL_MARGIN_MD}px)`,
      minHeight: `calc(100vh - ${VERTICAL_MARGIN_MD}px)`,
      maxHeight: `calc(100vh - ${VERTICAL_MARGIN_MD}px)`,
      height: `calc(100vh - ${VERTICAL_MARGIN_MD}px)`,

      [theme.breakpoints.down(Breakpoints.SM_600)]: {
        minWidth: `calc(100vw - ${HORIZONTAL_MARGIN_XS}px)`,
        width: `calc(100vw - ${HORIZONTAL_MARGIN_XS}px)`,
        minHeight: `calc(100vh - ${VERTICAL_MARGIN_XS}px)`,
        maxHeight: `calc(100vh - ${VERTICAL_MARGIN_XS}px)`,
        height: `calc(100vh - ${VERTICAL_MARGIN_XS}px)`
      }
    }
  },
  dialogCloseButton: {
    position: "absolute",
    top: 16,
    right: 20
  },
  dialogCloseButtonIcon: {
    fontSize: 24
  },
  dialogContent: {
    padding: 0,
    "& .react-pdf__message--error": {
      width: "max-content",
      position: "relative",
      left: "-70px"
    }
  },
  isLoadingErrorShown: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  pdfDocument: {
    height: "100%",
    width: "100%"
  },
  hidden: {
    display: "none"
  }
}));
